export type Role = Components.Schemas.Role;

export enum UniversalRoleIds {
	oracle = '1',
	companyAdministrator = '2',
	// Support role id is AUTO_INCREMENT — identify via Role.isSupport from the API, not a fixed id
}

export const emptyRole = (): Role => ({
	id: '',
	ownerEntityId: '',
	creatorName: '',
	name: '',
	isUniversal: false,
	isSentriLockOnly: false,
	isOracle: false,
	isCompanyAdmin: false,
	isSupport: false,
});

export type RoleDataItem = {
	role: Role;
	userCount: string;
	hasAuditLogsCapability: boolean;
};
